// @flow

export function getFbp(cookieStr: string): ?string {
  const regex = /(?:[\s;]|^)_fbp\s*=\s*([^;$]+)/;
  const result = regex.exec(cookieStr);
  if (result && result.length > 0) {
    return result[1];
  }
}
